/**
 * Which Hebrew years the app offers, and which one is now.
 *
 * Shared so two screens cannot disagree about what year it is — the schedule
 * and the year table both browse by it, and a list that differed between them
 * would be two answers to one question.
 */

/** Civil + 3760, and one more from Rosh Hashana on (~September). */
export const CURRENT_HEBREW_YEAR = (() => {
  const now = new Date()
  return now.getFullYear() + 3760 + (now.getMonth() >= 8 ? 1 : 0)
})()

/** A year back so last year's sheet is reachable, then forward. */
export const YEARS = Array.from(
  { length: 16 },
  (_, i) => CURRENT_HEBREW_YEAR - 1 + i,
)
